export default __webpack_public_path__ + "static/media/Head_4_Ear_2_C4.89441af3.svg";